import { render, staticRenderFns } from "./DetailModalEdit.vue?vue&type=template&id=5715e5c0"
import script from "./DetailModalEdit.vue?vue&type=script&lang=js"
export * from "./DetailModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports